module.exports = __webpack_public_path__ + "static/card-fa-de73c4b3448ca6c5024695718253f656.png";